<template>
  <v-container fluid>
    <v-row>
      <v-col cols="3" class="sidebar">
        <v-list density="compact">
          <v-list-item
            v-for="(section, index) in metadata.chapters"
            :key="index"
            @click="selectedChapter = section"
            :class="{'active-chapter': selectedChapter && selectedChapter.title === section.title}"
          >
            {{ section.title }}
          </v-list-item>
        </v-list>
      </v-col>

      <v-col cols="9" class="content">
        <section v-if="selectedChapter">          
          <v-md-preview :text="formatMarkdown(selectedChapter.content)"></v-md-preview>          
        </section>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const metadata = ref({ chapters: [] });
const selectedChapter = ref(null); // Almacena el capítulo visible



// Función para ajustar las rutas de imágenes a rutas absolutas
const formatMarkdown = (content) => {
  return content.replace(/assets\//g, "/docs/assets/");
};


const fetchMetadata = async () => {
  const response = await fetch('/docs/metadata.json');
  metadata.value = await response.json();

  for (let chapter of metadata.value.chapters) {
    const mdResponse = await fetch(`/docs/${chapter.file}`);
    chapter.content = await mdResponse.text();
  }

  // Mostrar el primer capítulo al cargar
  if (metadata.value.chapters.length > 0) {
    selectedChapter.value = metadata.value.chapters[0];
  }
};

onMounted(fetchMetadata);
</script>

<style scoped>
.sidebar {
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
  background: #f5f5f5;
  padding: 16px;
}

.content {
  padding: 16px;
}
.active-chapter {
    background-color: #a3d3f3 !important; 
    font-weight: bold;
    border-radius: 5px;
  }
</style>
